"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModulesTables = exports.getMajorList = exports.getFileByUrl = exports.getDictDataByDictType = void 0;
var _api = _interopRequireDefault(require("@/libs/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 *  注意：
 *  1：request 里面得传递参数可以有两种
 *    1）：data
 *        这是以body方式传递参数
 *        例如：
 *        一：data: params  //post body方式 {key:value,key:value,}
 *        二：data: {
            item: userIds
          } 形成得格式：{item:xxxxx}
 *    2）：params
 *        这是以url传递参数
 *        例如：
 *        params: {
            id: userId  // url请求方式  getUserById?id=userId
          }
 *
 */

/**
 * 请求表格接口
 * @param url 接口地址
 * @param methed  请求方式
 * @param queryParams 请求参数
 * @returns {*|AxiosPromise<any>|void}
 */
var getModulesTables = exports.getModulesTables = function getModulesTables(url, methed, queryParams) {
  return _api.default.request({
    // 这里返回的是一个Promise，request方法传入一个配置对象，配置项可参考axios
    url: url,
    method: methed,
    params: queryParams
  });
};

/**
 * 根据type 查询字典数据
 * @param dictType
 * @returns {*|AxiosPromise<any>}
 */
var getDictDataByDictType = exports.getDictDataByDictType = function getDictDataByDictType(dictType) {
  return _api.default.request({
    url: '/system/dict-data/getDictDataListByDictType',
    params: {
      dictType: dictType
    }
  });
};

// 获取专业大类列表
var getMajorList = exports.getMajorList = function getMajorList(data) {
  return _api.default.request({
    url: '/system/major/classes/list',
    method: 'get',
    params: data
  });
};

// 根据url获取文件预览快照
var getFileByUrl = exports.getFileByUrl = function getFileByUrl(data) {
  return _api.default.request({
    url: '/uploadFile/getFileByUrl',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};